import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, mergeProps as _mergeProps, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { id: "formulario" }
const _hoisted_2 = { class: "container mx-auto max-w-7xl my-7 p-5 lg:p-8 lg:pr-10 bg-white bg-opacity-90 rounded-lg shadow-xl" }
const _hoisted_3 = { class: "font-bold text-center text-2xl" }
const _hoisted_4 = { class: "font-bold text-center text-xl" }
const _hoisted_5 = { class: "font-bold text-lg mt-5" }
const _hoisted_6 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-2" }
const _hoisted_7 = { class: "w-full px-2 md:w-4/12" }
const _hoisted_8 = { class: "block mb-1" }
const _hoisted_9 = { class: "text-sm text-red-500 p-error" }
const _hoisted_10 = { class: "w-full px-2 md:w-4/12" }
const _hoisted_11 = { class: "block mb-1" }
const _hoisted_12 = { class: "text-sm text-red-500 p-error" }
const _hoisted_13 = { class: "w-full px-2 md:w-4/12" }
const _hoisted_14 = { class: "block mb-1" }
const _hoisted_15 = { class: "text-sm text-red-500 p-error" }
const _hoisted_16 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-2" }
const _hoisted_17 = { class: "w-full px-2 md:w-6/12" }
const _hoisted_18 = { class: "block mb-1" }
const _hoisted_19 = { class: "text-sm text-red-500 p-error" }
const _hoisted_20 = { class: "w-full px-2 md:w-6/12" }
const _hoisted_21 = { class: "block mb-1" }
const _hoisted_22 = { class: "text-sm text-red-500 p-error" }
const _hoisted_23 = { class: "font-bold text-lg mt-8" }
const _hoisted_24 = ["onClick"]
const _hoisted_25 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0" }
const _hoisted_26 = { class: "w-full px-2 md:w-4/12" }
const _hoisted_27 = { class: "block mb-1" }
const _hoisted_28 = { class: "text-sm text-red-500 p-error" }
const _hoisted_29 = { class: "w-full px-2 md:w-4/12" }
const _hoisted_30 = { class: "block mb-1" }
const _hoisted_31 = { class: "text-sm text-red-500 p-error" }
const _hoisted_32 = { class: "w-full px-2 md:w-4/12" }
const _hoisted_33 = { class: "block mb-1" }
const _hoisted_34 = { class: "text-sm text-red-500 p-error" }
const _hoisted_35 = { class: "mt-4" }
const _hoisted_36 = { class: "flex flex-wrap py-2 mt-3 jusi" }
const _hoisted_37 = ["disabled"]
const _hoisted_38 = { class: "pi pi-spin pi-spinner mr-2" }
const _hoisted_39 = { class: "pi pi-check mr-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeaderSection = _resolveComponent("HeaderSection")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Field = _resolveComponent("Field")!
  const _component_BlockUI = _resolveComponent("BlockUI")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_HeaderSection),
    _createElementVNode("section", _hoisted_1, [
      _createVNode(_component_Form, {
        onSubmit: _ctx.onSubmit,
        "validation-schema": _ctx.schema,
        class: "space-y-4 text-gray-700 mx-5",
        onInvalidSubmit: _ctx.onInvalidSubmit
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.$t('titulo.acreditacion.colegios')), 1),
            _createElementVNode("h1", _hoisted_4, _toDisplayString(_ctx.$t('label.complete.el.form')), 1),
            _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.$t('label.datos.coordinador')), 1),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.$t('label.documento')), 1),
                _createVNode(_component_Field, {
                  name: "dni",
                  modelValue: _ctx.formData.dni,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.dni) = $event))
                }, {
                  default: _withCtx(({ field, errors }) => [
                    _createVNode(_component_InputText, _mergeProps(field, {
                      type: "text",
                      class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }],
                      placeholder: _ctx.$t('label.documento')
                    }), null, 16, ["placeholder", "class"]),
                    _createElementVNode("span", _hoisted_9, [
                      _createVNode(_component_ErrorMessage, { name: "dni" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("label", _hoisted_11, _toDisplayString(_ctx.$t('label.nombre')), 1),
                _createVNode(_component_Field, {
                  name: "nombre",
                  modelValue: _ctx.formData.nombre,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.nombre) = $event))
                }, {
                  default: _withCtx(({ field, errors }) => [
                    _createVNode(_component_InputText, _mergeProps(field, {
                      type: "text",
                      class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }],
                      placeholder: _ctx.$t('label.nombre')
                    }), null, 16, ["placeholder", "class"]),
                    _createElementVNode("span", _hoisted_12, [
                      _createVNode(_component_ErrorMessage, { name: "nombre" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("label", _hoisted_14, _toDisplayString(_ctx.$t('label.apellido')), 1),
                _createVNode(_component_Field, {
                  name: "apellido",
                  modelValue: _ctx.formData.apellido,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.apellido) = $event))
                }, {
                  default: _withCtx(({ field, errors }) => [
                    _createVNode(_component_InputText, _mergeProps(field, {
                      type: "text",
                      class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }],
                      placeholder: _ctx.$t('label.apellido')
                    }), null, 16, ["placeholder", "class"]),
                    _createElementVNode("span", _hoisted_15, [
                      _createVNode(_component_ErrorMessage, { name: "apellido" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.$t('label.empresa')) + " " + _toDisplayString(_ctx.$t('label.institucion')), 1),
                _createVNode(_component_Field, {
                  name: "empresa",
                  modelValue: _ctx.formData.empresa,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.empresa) = $event))
                }, {
                  default: _withCtx(({ field, errors }) => [
                    _createVNode(_component_InputText, _mergeProps(field, {
                      type: "text",
                      class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }],
                      placeholder: _ctx.$t('label.empresa')
                    }), null, 16, ["placeholder", "class"]),
                    _createElementVNode("span", _hoisted_19, [
                      _createVNode(_component_ErrorMessage, { name: "empresa" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("label", _hoisted_21, _toDisplayString(_ctx.$t('label.mail')), 1),
                _createVNode(_component_Field, {
                  name: "mail",
                  modelValue: _ctx.formData.mail,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.mail) = $event))
                }, {
                  default: _withCtx(({ field, errors }) => [
                    _createVNode(_component_InputText, _mergeProps(field, {
                      type: "text",
                      class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }],
                      placeholder: _ctx.$t('label.mail')
                    }), null, 16, ["placeholder", "class"]),
                    _createElementVNode("span", _hoisted_22, [
                      _createVNode(_component_ErrorMessage, { name: "mail" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("h2", _hoisted_23, _toDisplayString(_ctx.$t('label.alumnos')), 1),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formData.alumnos, (alumno, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "p-4 border rounded-lg mt-3 bg-gray-50 relative"
              }, [
                _createElementVNode("button", {
                  type: "button",
                  onClick: ($event: any) => (_ctx.removeAlumno(index)),
                  class: "absolute top-2 right-2 text-red-600 hover:text-red-800 font-bold"
                }, [...(_cache[6] || (_cache[6] = [
                  _createElementVNode("i", { class: "pi pi-times" }, null, -1)
                ]))], 8, _hoisted_24),
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("div", _hoisted_26, [
                    _createElementVNode("label", _hoisted_27, _toDisplayString(_ctx.$t('label.documento')), 1),
                    _createVNode(_component_Field, {
                      name: `alumnos[${index}].dni`,
                      modelValue: alumno.dni,
                      "onUpdate:modelValue": ($event: any) => ((alumno.dni) = $event)
                    }, {
                      default: _withCtx(({ field, errors }) => [
                        _createVNode(_component_InputText, _mergeProps({ ref_for: true }, field, {
                          type: "text",
                          class: ["input-base", { 'bg-white': true, 'input-error': errors.length > 0 }],
                          placeholder: _ctx.$t('label.documento')
                        }), null, 16, ["placeholder", "class"]),
                        _createElementVNode("span", _hoisted_28, [
                          _createVNode(_component_ErrorMessage, {
                            name: `alumnos[${index}].dni`
                          }, null, 8, ["name"])
                        ])
                      ]),
                      _: 2
                    }, 1032, ["name", "modelValue", "onUpdate:modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_29, [
                    _createElementVNode("label", _hoisted_30, _toDisplayString(_ctx.$t('label.nombre')), 1),
                    _createVNode(_component_Field, {
                      name: `alumnos[${index}].nombre`,
                      modelValue: alumno.nombre,
                      "onUpdate:modelValue": ($event: any) => ((alumno.nombre) = $event)
                    }, {
                      default: _withCtx(({ field, errors }) => [
                        _createVNode(_component_InputText, _mergeProps({ ref_for: true }, field, {
                          type: "text",
                          class: ["input-base", { 'bg-white': true, 'input-error': errors.length > 0 }],
                          placeholder: _ctx.$t('label.nombre')
                        }), null, 16, ["placeholder", "class"]),
                        _createElementVNode("span", _hoisted_31, [
                          _createVNode(_component_ErrorMessage, {
                            name: `alumnos[${index}].nombre`
                          }, null, 8, ["name"])
                        ])
                      ]),
                      _: 2
                    }, 1032, ["name", "modelValue", "onUpdate:modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_32, [
                    _createElementVNode("label", _hoisted_33, _toDisplayString(_ctx.$t('label.apellido')), 1),
                    _createVNode(_component_Field, {
                      name: `alumnos[${index}].apellido`,
                      modelValue: alumno.apellido,
                      "onUpdate:modelValue": ($event: any) => ((alumno.apellido) = $event)
                    }, {
                      default: _withCtx(({ field, errors }) => [
                        _createVNode(_component_InputText, _mergeProps({ ref_for: true }, field, {
                          type: "text",
                          class: ["input-base", { 'bg-white': true, 'input-error': errors.length > 0 }],
                          placeholder: _ctx.$t('label.apellido')
                        }), null, 16, ["placeholder", "class"]),
                        _createElementVNode("span", _hoisted_34, [
                          _createVNode(_component_ErrorMessage, {
                            name: `alumnos[${index}].apellido`
                          }, null, 8, ["name"])
                        ])
                      ]),
                      _: 2
                    }, 1032, ["name", "modelValue", "onUpdate:modelValue"])
                  ])
                ])
              ]))
            }), 128)),
            _createElementVNode("div", _hoisted_35, [
              _createElementVNode("button", {
                type: "button",
                onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.addAlumno && _ctx.addAlumno(...args))),
                class: "px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700"
              }, [
                _cache[7] || (_cache[7] = _createElementVNode("i", { class: "pi pi-plus mr-2" }, null, -1)),
                _createTextVNode(" " + _toDisplayString(_ctx.$t('label.agregar.alumno')), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_36, [
              _createElementVNode("button", {
                type: "submit",
                class: "mt-8 px-4 py-2 bg-transparent border-blue-950 hover:bg-cyan-600 text-blue-950 font-semibold hover:text-white border rounded",
                disabled: _ctx.isSubmitting
              }, [
                _withDirectives(_createElementVNode("i", _hoisted_38, null, 512), [
                  [_vShow, _ctx.isSubmitting]
                ]),
                _withDirectives(_createElementVNode("i", _hoisted_39, null, 512), [
                  [_vShow, !_ctx.isSubmitting]
                ]),
                _createTextVNode(" " + _toDisplayString(_ctx.$t('boton.registrarme')), 1)
              ], 8, _hoisted_37)
            ])
          ]),
          _createVNode(_component_BlockUI, {
            blocked: _ctx.isSubmitting,
            fullScreen: ""
          }, null, 8, ["blocked"])
        ]),
        _: 1
      }, 8, ["onSubmit", "validation-schema", "onInvalidSubmit"])
    ])
  ], 64))
}